import React from 'react';
import {
  FormControlLabel,
  Typography,
  Button,
  FormControl,
  Link,
  Checkbox,
} from '@mui/material';
import FormControlError from '~/_base/components/formControlError';
import { useForm } from 'react-hook-form';

const isDevelopment = process.env.NODE_ENV === 'development';

interface StepFourProps {
  onCreate: (recaptcha_code_v3: string) => Promise<void>;
  onPrevious: () => void;
}

export default function StepFour({ onPrevious, onCreate }: StepFourProps) {
  const { register, handleSubmit, formState: { errors } } = useForm();

  async function getCaptchaAndSubmit() {
    if (isDevelopment) {
      // Development - Bypass Captcha
      onCreate('');
    } else {
      // Production
      const trialSetupEl = document.getElementById('react-trial-setup');
      const key = trialSetupEl?.getAttribute('data-recaptcha-v3-sitekey') ?? '';
      const token = await (window as any).grecaptcha.execute(key, {
        action: 'submit_trial_setup_wizard',
      });
      onCreate(token);
    }
  }

  return (
    <form onSubmit={handleSubmit(getCaptchaAndSubmit)}>
      <Typography variant="h1" style={{ marginBottom: 24 }}>
        Terms & Conditions
      </Typography>
      <FormControl
        variant="standard"
        required
        fullWidth
        error={errors.terms != null}
        style={{ marginBottom: 16 }}>
        {errors.terms && (
          <FormControlError message="Please agree to the terms & conditions" />
        )}
        <FormControlLabel
          control={
            <Checkbox {...register('terms', { required: true })} />
          }
          label={
            <Typography variant="body1">
              {'I have read and agree to the '}
              <Link
                href="https://www.damstratechnology.com/terms-conditions#terms-conditions"
                target="_blank">
                terms & conditions
              </Link>
            </Typography>
          }
        />
      </FormControl>
      <div
        style={{
          marginTop: 16,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button variant="contained" style={{ width: 120 }} onClick={onPrevious}>
          Previous
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ width: 120 }}
        >
          Create
        </Button>
      </div>
    </form>
  );
}
